import React, { Children, useEffect, useState } from "react"
import PropTypes from "prop-types"
// Style
import { HeaderGantt } from "../index.style"

const StepHeader = ({ columns, color }) => {
  const nbColumns = columns?.length

  return (
    <HeaderGantt nbColumns={nbColumns} color={color}>
      <div></div>
      {Children.toArray(
        columns?.map(item => {
          return <div className="cellCol">{item}</div>
        })
      )}
    </HeaderGantt>
  )
}

StepHeader.propTypes = {
  columns: PropTypes.array,
  color: PropTypes.string,
}

StepHeader.defaultProps = {
  columns: [],
  color: "",
}

export default StepHeader
